import axios from 'axios';

export const BOOKINGS_LOADING = 'BOOKINGS_LOADING';
export const BOOKINGS_SUCCESS = 'BOOKINGS_SUCCESS';
export const BOOKINGS_ERROR = 'BOOKINGS_ERROR';

export const BOOKINGS_PERIOD_LOADING = 'BOOKINGS_PERIOD_LOADING';
export const BOOKINGS_PERIOD_SUCCESS = 'BOOKINGS_PERIOD_SUCCESS';
export const BOOKINGS_PERIOD_ERROR = 'BOOKINGS_PERIOD_ERROR';

export const PAST_BOOKINGS_LOADING = 'PAST_BOOKINGS_LOADING';
export const PAST_BOOKINGS_SUCCESS = 'PAST_BOOKINGS_SUCCESS';
export const PAST_BOOKINGS_ERROR = 'PAST_BOOKINGS_ERROR';

export const PENDING_BOOKINGS_LOADING = 'PENDING_BOOKINGS_LOADING';
export const PENDING_BOOKINGS_SUCCESS = 'PENDING_BOOKINGS_SUCCESS';
export const PENDING_BOOKINGS_ERROR = 'PENDING_BOOKINGS_ERROR';

export function fetchBookings(page = 0) {
  return async (dispatch, getState) => {
    const state = getState();

    if (!state.user.token) {
      return;
    }

    dispatch({ type: BOOKINGS_LOADING });
    axios
      .get(`${process.env.REACT_APP_BACKEND_URL}/appointments`, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${state.user.token}`
        },
        params: { page }
      })
      .then(response => {
        dispatch({
          type: BOOKINGS_SUCCESS,
          payload: response,
          total: response.data.total,
          page_size: response.data.page_size
        });
      })
      .catch(result => {
        dispatch({
          type: BOOKINGS_ERROR,
          payload: result
        });
      });
  };
}

export function fetchBookingHistory(page = 0) {
  return async (dispatch, getState) => {
    const state = getState();

    if (!state.user.token) {
      return;
    }

    dispatch({ type: BOOKINGS_PERIOD_LOADING });

    axios
      .get(`${process.env.REACT_APP_BACKEND_URL}/appointments/history`, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${state.user.token}`
        },
        params: { page }
      })
      .then(response => {
        dispatch({
          type: BOOKINGS_PERIOD_SUCCESS,
          payload: response.data.data,
          total: response.data.total,
          page_size: response.data.page_size
        });
      })
      .catch(result => {
        dispatch({
          type: BOOKINGS_PERIOD_ERROR,
          payload: result
        });
      });
  };
}

export function fetchPendingBookings(page = 0) {
  return async (dispatch, getState) => {
    const state = getState();

    if (!state.user.token) {
      return;
    }

    dispatch({ type: PENDING_BOOKINGS_LOADING });

    axios
      .get(`${process.env.REACT_APP_BACKEND_URL}/appointments/pending`, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${state.user.token}`
        },
        params: { page }
      })
      .then(response => {
        dispatch({
          type: PENDING_BOOKINGS_SUCCESS,
          payload: response.data.data,
          total: response.data.total,
          page_size: response.data.page_size
        });
      })
      .catch(result => {
        dispatch({
          type: PENDING_BOOKINGS_ERROR,
          payload: result
        });
      });
  };
}

function getCachedRecentBookings(userId) {
  const now = new Date().getTime();
  const key = 'recent-bookings-' + userId;
  let recentBookings = localStorage.getItem(key);
  if (recentBookings) {
    recentBookings = JSON.parse(recentBookings);
    if (now < recentBookings.expires) {
      return recentBookings.data;
    }
  }
  return null;
}

// TODO: We can probably remove this caching now that we're not using onsched and our
// API calls will be fast
function setCachedRecentBookings(userId, bookings) {
  const now = new Date().getTime();
  const key = 'recent-bookings-' + userId;
  const expires = now + 1000 * 60 * 5; // Cache for 5 minutes from now
  localStorage.setItem(
    key,
    JSON.stringify({
      expires,
      data: bookings
    })
  );
}

export function fetchRecentBookings() {
  return async (dispatch, getState) => {
    const state = getState();

    if (!state.user.token) {
      return;
    }

    const cached = getCachedRecentBookings(state.user.id);
    if (cached) {
      dispatch({
        type: BOOKINGS_PERIOD_SUCCESS,
        payload: cached
      });
      return;
    }

    dispatch({ type: BOOKINGS_PERIOD_LOADING });

    axios
      .get(`${process.env.REACT_APP_BACKEND_URL}/appointments/recent`, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${state.user.token}`
        }
      })
      .then(response => {
        setCachedRecentBookings(state.user.id, response.data.data);
        dispatch({
          type: BOOKINGS_PERIOD_SUCCESS,
          payload: response.data.data
        });
      })
      .catch(result => {
        dispatch({
          type: BOOKINGS_PERIOD_ERROR,
          payload: result
        });
      });
  };
}



// WEBPACK FOOTER //
// ./src/actions/bookingActions.js